module.exports = __webpack_public_path__ + "img/s3.1a06df93.jpg";